module.exports = __webpack_public_path__ + "static/img/jkjcbg.eb15c30.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/img/jkjcbg.png
// module id = 2PU4
// module chunks = 1